<template
  ><v-card>
    <v-card-title>
      <span>{{ title }}</span>
      <v-spacer></v-spacer>
      <v-btn icon @click="close()">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-card-title>
    <v-card-text>
      <v-select
        v-model="model.typeId"
        :items="model.id ? activityTypes : availableTypes"
        label="Направление деятельности"
        item-text="name"
        item-value="id"
        :readonly="model.id > 0"
      />
      <v-text-field
        type="number"
        v-model="model.index"
        label="Коэффициент"
      ></v-text-field>
    </v-card-text>
    <v-card-actions>
      <v-btn depressed block @click="save">Сохранить</v-btn>
    </v-card-actions>
  </v-card>
</template>
<script>
export default {
  name: "RatingActivityTypeEditor",

  props: {
    value: Object,
    activityTypes: { type: Array, default: () => [] },
    availableTypes: { type: Array, default: () => [] }
  },

  data() {
    return {
      model: {}
    };
  },

  computed: {
    title() {
      return this.model.id
        ? "Редактирование коэффициента"
        : "Добавление вида деятельности";
    }
  },

  watch: {
    value: {
      handler(v) {
        this.model = { ...v };
      },
      immediate: true
    }
  },

  methods: {
    close() {
      this.$emit("close");
    },

    save() {
      this.$emit("input", this.model);
      this.$emit("save", this.model);
      this.close();
    }
  }
};
</script>
